import { Culture } from '../models/account/culture';
import { KreezeeSession } from '../models/account/kreezeeSession';

export function setKreezeeSession(kreezeesession: string): void {
  try {
    localStorage.setItem('__kreezeesession__', kreezeesession);
  } catch {}
}

export function getKreezeeSession(): KreezeeSession | null {
  try {
    const kreezeesession = localStorage.getItem('__kreezeesession__');
    if (kreezeesession) {
      return JSON.parse(kreezeesession);
    } else {
      return null;
    }
  } catch {
    return null;
  }
}

export function removeKreezeeSession(): void {
  try {
    localStorage.removeItem('__kreezeesession__');
  } catch {}
}

export function getLanguage(): Culture | null {
  try {
    const culture = localStorage.getItem('lang');
    if (culture === 'fr' || culture === 'en') {
      return culture;
    } else {
      return null;
    }
  } catch {
    return null;
  }
}

export function setLanguage(culture: Culture): void {
  try {
    localStorage.setItem('lang', culture);
  } catch {}
}

export function setOrganizationId(organizationId: string): void {
  try {
    localStorage.setItem('organizationId', organizationId);
  } catch {}
}

export function getOrganizationId(): string | null {
  try {
    const organizationId = localStorage.getItem('organizationId');
    if (organizationId) {
      return organizationId;
    } else {
      return null;
    }
  } catch {
    return null;
  }
}

export function removeOrganizationId(): void {
  try {
    localStorage.removeItem('organizationId');
  } catch {}
}
